import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 主题蓝色
  colorPrimary: '#2563eb',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'AI Nexus',
  pwa: true,
  logo: '/logo.png',
  iconfontUrl: '',
  siderWidth: 250,
  token: {
    sider: {
      colorMenuBackground: '#fafafa',
      colorTextMenu: '#1f2937',
      colorTextMenuSelected: '#2563eb',
      colorBgMenuItemSelected: '#eff6ff',
      colorTextMenuItemHover: '#2563eb',
      colorBgMenuItemHover: '#f3f4f6',
    },
    pageContainer: {
      colorBgPageContainer: '#ffffff',
    },
  },
};

export default Settings;
